const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_embed/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_embed")({
  params: {
    parse: params => window.V4_UI && new URLSearchParams(window.location.search).get("iframe") === "true" ? params : false
  },
  beforeLoad: () => ({
    isEmbed: true
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});